import React from "react";

export default function RefundPolicy() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1>Refund & Return Policy</h1>
      <p>Last updated: 05 December 2025</p>

      <h2>1. Returns</h2>
      <p>
        Items can be returned within 7 days of delivery in original, unused
        condition with tags intact. To start a return, contact our support
        team with your order ID.
      </p>

      <h2>2. Refunds</h2>
      <p>
        Once the returned item is received and inspected, refunds will be
        processed within 7–10 business days to your original payment method.
      </p>

      <h2>3. Non-returnable items</h2>
      <ul>
        <li>Used or damaged items</li>
        <li>Custom-made products</li>
        <li>Final sale items</li>
      </ul>

      <h2>4. Contact Us</h2>
      <p>
        For return/refund issues, contact: <br />
        📞 8770561028 <br />
        📧 support@kwicth.in
      </p>
    </div>
  );
}
